<div *ngIf="company" class="company-page">
  <div class="title">
    <h2 class="vox-heading-2">
      <i class="icon-small-arrow-left" routerLink="/dashboard/companies"
        [ngbTooltip]="'company.back-to-list' | translate" style="cursor: pointer;"></i>
      {{company.name}}
    </h2>
    <div class="vox-paragraph">
      <div class="vox-chip vox-chip_royal-blue mb-1">Alphaname: {{company.alphaname}}</div>
    </div>
    <div class="vox-paragraph">
      <div class="vox-chip vox-chip_royal-blue mb-1">CompanyID: {{company.companyId}}</div>
      <div class="vox-chip vox-chip_royal-blue mb-1">BillingID: {{company.billingId}}</div>
      <div class="vox-chip vox-chip_royal-blue mb-1">PBXID: {{company.pbxId}}</div>

    </div>
    <div *ngIf="company.readOnly" class="vox-paragraph">
      <div class="vox-chip vox-chip_bright-crimson-text mb-1" translate>company.disclaimer-read-only</div>
    </div>
  </div>
  <hr>
  <div class="company-main-container">
    <div ngbDropdown class="vox-dropdown-input">
      <button ngbDropdownToggle>
        <span>
          <i [ngClass]="TAB_ICONS[currentTab]"></i>
          {{('company.tabs.'+ currentTab) | translate }}
        </span>
      </button>
      <div ngbDropdownMenu>
        <ng-container *ngFor="let tab of TABS">
          <button ngbDropdownItem (click)="switchTab(tab)">
            <i [ngClass]="TAB_ICONS[tab]"></i>
            <span>{{'company.tabs.' + tab | translate}}</span>
          </button>
        </ng-container>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" [activeId]="currentTab" (navChange)="onNavChange($event)" class="nav-pills"
      orientation="vertical">
      <li *ngFor="let tab of TABS" [ngbNavItem]="tab">
        <a ngbNavLink routerLink="../{{tab}}" [title]="'company.tabs.' + tab | translate">
          <i [ngClass]="TAB_ICONS[tab]"></i>
          <span>{{'company.tabs.' + tab | translate}}</span>
        </a>
        <ng-template ngbNavContent [ngSwitch]="tab">
          <gdp-company-overview *ngSwitchCase="'overview'" [company]="company" (companyChanged)="company = $event">
          </gdp-company-overview>
          <gdp-company-users *ngSwitchCase="'users'" [company]="company"></gdp-company-users>
          <gdp-company-fax *ngSwitchCase="'fax'" [company]="company"></gdp-company-fax>
          <gdp-company-dids *ngSwitchCase="'dids'" [company]="company"></gdp-company-dids>
          <gdp-company-trial-kit *ngSwitchCase="'trial-kit'" [company]="company"></gdp-company-trial-kit>
          <gdp-company-queues *ngSwitchCase="'queues'" [company]="company"></gdp-company-queues>
          <gdp-company-equipment *ngSwitchCase="'equipment'" [company]="company"></gdp-company-equipment>
          <gdp-company-integrations *ngSwitchCase="'integrations'" [company]="company"></gdp-company-integrations>
          <gdp-company-connectivity-main *ngSwitchCase="'connectivity'" [company]="company"></gdp-company-connectivity-main>
          <gdp-company-reviews *ngSwitchCase="'reviews'" [company]="company"></gdp-company-reviews>
          <gdp-company-sms *ngSwitchCase="'sms'" [company]="company"></gdp-company-sms>
          <gdp-company-support-devices *ngSwitchCase="'support-devices'" [company]="company">
          </gdp-company-support-devices>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="company-main-tab-container"></div>
  </div>
</div>
<div *ngIf="!company && !error" class="company-page">
  <div class="title mt-2">
    <h2>
      <ngx-skeleton-loader [theme]="{'height': '48px', 'margin-bottom' : 0, 'margin-left': '16px'}">
      </ngx-skeleton-loader>
    </h2>
    <div class="vox-paragraph">
      <ngx-skeleton-loader class="vox-chip" count="1"
        [theme]="{'height': '24px', 'width': '170px', 'margin-left': '5px', 'margin-bottom': 0}"></ngx-skeleton-loader>
    </div>
    <div class="vox-paragraph">
      <ngx-skeleton-loader class="vox-chip" count="3"
        [theme]="{'height': '24px', 'width': '120px', 'margin-left': '5px', 'margin-bottom': 0}"></ngx-skeleton-loader>
    </div>
  </div>
  <hr />
  <div class="company-main-container">
    <ul class="nav-tabs nav mb-0 mt-3 d-none d-xl-block" style="max-width: 130px; margin-left: 20px; ">
      <ngx-skeleton-loader class="nav-item" count="8"
        [theme]="{'height': '80px', 'width': '100px', 'margin-left': '3px'}"></ngx-skeleton-loader>
    </ul>
    <div class="company-main-tab-container">
      <ngx-skeleton-loader class="nav-item" count="8" [theme]="{'height': '56px'}"></ngx-skeleton-loader>
    </div>
  </div>
</div>
<div *ngIf="!company && error" class="company-page">
  <div class="vox-inline-message vox-inline-message_light-grey m-3">
    <div>
      <i class="icon-small-alert"></i>
      <span translate>company.error</span>
    </div>
  </div>
</div>
